/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  StripeTransactionFull,
  StripeTransactionFullOptional,
  StripeTransactionFullMetaI,
  StripeTransactionFullTrackedI,
} from "./stripe-transaction-full";
import {
  StripeTransactionFullTracked,
  StripeTransactionFullMeta,
} from "./stripe-transaction-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  StripeTransactionType,
  StripeTransactionTypeOptional,
  StripeTransactionTypeMetaI,
  StripeTransactionTypeTrackedI,
} from "./stripe-transaction-type";
import {
  StripeTransactionTypeTracked,
  StripeTransactionTypeMeta,
} from "./stripe-transaction-type";

/**
 *
 * @export
 * @interface StripeTransactionDTO
 */
export interface StripeTransactionDTOOptional extends StripeTransactionFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof StripeTransactionDTO
   */
  assignId?: number;
  /**
   *
   * @type {StripeTransactionType}
   * @memberof StripeTransactionDTO
   */
  transactionType?: StripeTransactionType;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionDTO
   */
  stripePaymentIntent?: string;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionDTO
   */
  stripePaymentSecret?: string;
  /**
   *
   * @type {number}
   * @memberof StripeTransactionDTO
   */
  transactionAmountCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionDTO
   */
  offSession?: boolean;
}

export interface StripeTransactionDTO
  extends StripeTransactionDTOOptional, StripeTransactionFull {
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof StripeTransactionDTO
   */
  assignId: number;
  /**
   *
   * @type {StripeTransactionType}
   * @memberof StripeTransactionDTO
   */
  transactionType?: StripeTransactionType;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionDTO
   */
  stripePaymentIntent: string;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionDTO
   */
  stripePaymentSecret?: string;
  /**
   *
   * @type {number}
   * @memberof StripeTransactionDTO
   */
  transactionAmountCents: number;
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionDTO
   */
  offSession?: boolean;
}

export interface StripeTransactionDTOTrackedI extends StripeTransactionFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof StripeTransactionDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {StripeTransactionType}
   * @memberof StripeTransactionDTO
   */
  transactionType?: StripeTransactionType;
  transactionTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionDTO
   */
  stripePaymentIntent?: string;
  stripePaymentIntentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof StripeTransactionDTO
   */
  stripePaymentSecret?: string;
  stripePaymentSecretIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof StripeTransactionDTO
   */
  transactionAmountCents?: number;
  transactionAmountCentsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof StripeTransactionDTO
   */
  offSession?: boolean;
  offSessionIsSet: boolean;
}

transformDatesMap.set(
  "StripeTransactionDTO",
  function (model: StripeTransactionDTO) {},
);

export type StripeTransactionDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  transactionType: PropertyMeta<StripeTransactionTypeMetaI>;
  //isDate: false
  //isDatetime: false
  stripePaymentIntent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  stripePaymentSecret: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  transactionAmountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  offSession: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var StripeTransactionDTOMeta: StripeTransactionDTOMetaI =
  {} as StripeTransactionDTOMetaI;
StripeTransactionDTOMeta = typeMeta("StripeTransactionDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  transactionType: propertyMeta(
    "transactionType",
    false,
    false,
    false,
    StripeTransactionTypeMeta,
  ),
  stripePaymentIntent: propertyMeta(
    "stripePaymentIntent",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  stripePaymentSecret: propertyMeta(
    "stripePaymentSecret",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  transactionAmountCents: propertyMeta(
    "transactionAmountCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  offSession: propertyMeta(
    "offSession",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = StripeTransactionDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([StripeTransactionFullMeta]);
  metaI.isDeleted.inheritedFrom = StripeTransactionFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = StripeTransactionFullMeta.isNew;
  metaI.assignId.inheritedFrom = StripeTransactionFullMeta.assignId;
  metaI.transactionType.inheritedFrom =
    StripeTransactionFullMeta.transactionType;
  metaI.stripePaymentIntent.inheritedFrom =
    StripeTransactionFullMeta.stripePaymentIntent;
  metaI.stripePaymentSecret.inheritedFrom =
    StripeTransactionFullMeta.stripePaymentSecret;
  metaI.transactionAmountCents.inheritedFrom =
    StripeTransactionFullMeta.transactionAmountCents;
  metaI.offSession.inheritedFrom = StripeTransactionFullMeta.offSession;
});

export class StripeTransactionDTOTracked
  extends StripeTransactionFullTracked
  implements StripeTransactionDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  transactionType__I?: StripeTransactionType = undefined;
  transactionTypeIsSet: boolean = false;
  set transactionType(v: undefined | StripeTransactionType) {
    if (v !== undefined) {
      this.transactionType__I = v;
      this.transactionTypeIsSet = true;
    } else {
      this.transactionType__I = v || undefined;
      this.transactionTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionType() {
    return this.transactionType__I;
  }
  stripePaymentIntent__I?: string = undefined;
  stripePaymentIntentIsSet: boolean = false;
  set stripePaymentIntent(v: undefined | string) {
    if (v !== undefined) {
      this.stripePaymentIntent__I = v;
      this.stripePaymentIntentIsSet = true;
    } else {
      this.stripePaymentIntent__I = v || undefined;
      this.stripePaymentIntentIsSet = true;
    }
    this.changeTracker = true;
  }
  get stripePaymentIntent() {
    return this.stripePaymentIntent__I;
  }
  stripePaymentSecret__I?: string = undefined;
  stripePaymentSecretIsSet: boolean = false;
  set stripePaymentSecret(v: undefined | string) {
    if (v !== undefined) {
      this.stripePaymentSecret__I = v;
      this.stripePaymentSecretIsSet = true;
    } else {
      this.stripePaymentSecret__I = v || undefined;
      this.stripePaymentSecretIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripePaymentSecret() {
    return this.stripePaymentSecret__I;
  }
  transactionAmountCents__I?: number = undefined;
  transactionAmountCentsIsSet: boolean = false;
  set transactionAmountCents(v: undefined | number) {
    if (v !== undefined) {
      this.transactionAmountCents__I = v;
      this.transactionAmountCentsIsSet = true;
    } else {
      this.transactionAmountCents__I = v || undefined;
      this.transactionAmountCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get transactionAmountCents() {
    return this.transactionAmountCents__I;
  }
  offSession__I?: boolean = undefined;
  offSessionIsSet: boolean = false;
  set offSession(v: undefined | boolean) {
    if (v !== undefined) {
      this.offSession__I = v;
      this.offSessionIsSet = true;
    } else {
      this.offSession__I = v || undefined;
      this.offSessionIsSet = false;
    }
    this.changeTracker = true;
  }
  get offSession() {
    return this.offSession__I;
  }
  constructor(config?: StripeTransactionDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: StripeTransactionDTOOptional,
    options?: AssignOptions,
  ): StripeTransactionDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.transactionType &&
      this.transactionTypeApplyFilter(optionsRequired.filter)
    ) {
      this.transactionType = config.transactionType;
      if (optionsRequired.unassign) this.transactionTypeIsSet = false;
      else this.transactionTypeIsSet = true;
    }
    if (
      config.stripePaymentIntent &&
      this.stripePaymentIntentApplyFilter(optionsRequired.filter)
    ) {
      this.stripePaymentIntent = config.stripePaymentIntent;
      if (optionsRequired.unassign) this.stripePaymentIntentIsSet = false;
      else this.stripePaymentIntentIsSet = true;
    }
    if (
      config.stripePaymentSecret &&
      this.stripePaymentSecretApplyFilter(optionsRequired.filter)
    ) {
      this.stripePaymentSecret = config.stripePaymentSecret;
      if (optionsRequired.unassign) this.stripePaymentSecretIsSet = false;
      else this.stripePaymentSecretIsSet = true;
    }
    if (
      config.transactionAmountCents &&
      this.transactionAmountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.transactionAmountCents = config.transactionAmountCents;
      if (optionsRequired.unassign) this.transactionAmountCentsIsSet = false;
      else this.transactionAmountCentsIsSet = true;
    }
    if (
      config.offSession &&
      this.offSessionApplyFilter(optionsRequired.filter)
    ) {
      this.offSession = config.offSession;
      if (optionsRequired.unassign) this.offSessionIsSet = false;
      else this.offSessionIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): StripeTransactionDTOTrackedI {
    const cloned = {} as StripeTransactionDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.transactionTypeIsSetDeep() &&
      this.transactionTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionTypeIsSet = true;
      cloned.transactionType = this.transactionType;
    } else {
      //cloned.transactionTypeIsSet = false
    }
    if (
      this.stripePaymentIntentIsSetDeep() &&
      this.stripePaymentIntentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripePaymentIntentIsSet = true;
      cloned.stripePaymentIntent = this.stripePaymentIntent;
    } else {
      //cloned.stripePaymentIntentIsSet = false
    }
    if (
      this.stripePaymentSecretIsSetDeep() &&
      this.stripePaymentSecretApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripePaymentSecretIsSet = true;
      cloned.stripePaymentSecret = this.stripePaymentSecret;
    } else {
      //cloned.stripePaymentSecretIsSet = false
    }
    if (
      this.transactionAmountCentsIsSetDeep() &&
      this.transactionAmountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionAmountCentsIsSet = true;
      cloned.transactionAmountCents = this.transactionAmountCents;
    } else {
      //cloned.transactionAmountCentsIsSet = false
    }
    if (
      this.offSessionIsSetDeep() &&
      this.offSessionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.offSessionIsSet = true;
      cloned.offSession = this.offSession;
    } else {
      //cloned.offSessionIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): StripeTransactionDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.transactionTypeApplyFilter(filter))
      this.transactionTypeIsSet = false;

    if (!this.stripePaymentIntentApplyFilter(filter))
      this.stripePaymentIntentIsSet = false;

    if (!this.stripePaymentSecretApplyFilter(filter))
      this.stripePaymentSecretIsSet = false;

    if (!this.transactionAmountCentsApplyFilter(filter))
      this.transactionAmountCentsIsSet = false;

    if (!this.offSessionApplyFilter(filter)) this.offSessionIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionDTOMeta.isDeleted,
      StripeTransactionDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionDTOMeta.isNew,
      StripeTransactionDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionDTOMeta.assignId,
      StripeTransactionDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  transactionTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionDTOMeta.transactionType,
      StripeTransactionDTOMeta,
      this.transactionType,
      this,
    );
  }
  transactionTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.transactionTypeIsSet && this.transactionTypeApplyFilter(filter))
      return true;

    return false;
  }
  stripePaymentIntentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionDTOMeta.stripePaymentIntent,
      StripeTransactionDTOMeta,
      this.stripePaymentIntent,
      this,
    );
  }
  stripePaymentIntentIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripePaymentIntentIsSet &&
      this.stripePaymentIntentApplyFilter(filter)
    )
      return true;

    return false;
  }
  stripePaymentSecretApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionDTOMeta.stripePaymentSecret,
      StripeTransactionDTOMeta,
      this.stripePaymentSecret,
      this,
    );
  }
  stripePaymentSecretIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripePaymentSecretIsSet &&
      this.stripePaymentSecretApplyFilter(filter)
    )
      return true;

    return false;
  }
  transactionAmountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionDTOMeta.transactionAmountCents,
      StripeTransactionDTOMeta,
      this.transactionAmountCents,
      this,
    );
  }
  transactionAmountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionAmountCentsIsSet &&
      this.transactionAmountCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  offSessionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      StripeTransactionDTOMeta.offSession,
      StripeTransactionDTOMeta,
      this.offSession,
      this,
    );
  }
  offSessionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.offSessionIsSet && this.offSessionApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.transactionTypeIsSetDeep(filter)) return true;
    if (this.stripePaymentIntentIsSetDeep(filter)) return true;
    if (this.stripePaymentSecretIsSetDeep(filter)) return true;
    if (this.transactionAmountCentsIsSetDeep(filter)) return true;
    if (this.offSessionIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
